import { ProcessDocument } from '@/Modules/Processes/models'
import * as _ from 'lodash-es'
import { Component, Prop, Vue } from 'types-vue'


@Component
export default class TableFiles extends Vue {

  @Prop({ required: true, type: Array }) protected fileList: ProcessDocument[]


  protected loading: boolean = false

  protected get labelName(): string {
    return this.fileList?.length ? 'NOMBRE': ''
  }

  protected getFileIcon(extension: string) {
    return `fiv-icon-${extension.substring(1)}`
  }
}